<script lang="ts" setup>
	import { twMerge } from 'tailwind-merge'
	import type { Breadcrumb } from '../../types'

	defineOptions({inheritAttrs: false})

	defineProps<{
		items: Breadcrumb[]
		separatorIcon?:  string
		separatorClass?: string
		textClass?: string
		linkClass?: string
		noHome?: boolean
	}>()
	const Item = createReusableTemplate()
</script>

<template>
	<nav class="flex" aria-label="Breadcrumb">
		<ol role="list" class="flex" :class="twMerge(['space-x-3', 'px-6'], $attrs.class)">
			<Item.define #="{ page }">
				<GsIcon
					v-if="page.icon"
					:name="page.icon"
					class="w-full h-5"
					:class="{'mr-2': page.label}"
					preserveAspectRatio="true"
				/>
				{{ page.label }}
			</Item.define>

			<li class="flex" v-if="!noHome">
				<div class="flex items-center">
					<GsLink :to="{name: 'index'}" :class="twMerge('text-white hover:text-accent', linkClass)" no-prefetch>
						<UIcon name="i-mdi-home" class="size-6" aria-hidden="true" />
						<span class="sr-only">Home</span>
					</GsLink>
				</div>
			</li>

			<li v-for="(page, idx) in items" :key="page.label" class="flex">
				<div class="flex items-center">
					<template v-if="(noHome && idx > 0) || !noHome">
						<UIcon
							v-if="separatorIcon"
							:name="separatorIcon"
							:class="twMerge('size-5 text-current', separatorClass)"
						/>
						<svg
							v-else
							class="h-full w-6 flex-shrink-0"
							:class="twMerge('text-white', separatorClass)"
							viewBox="0 0 24 44" preserveAspectRatio="none" fill="currentColor" aria-hidden="true"
						>
							<path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
						</svg>
					</template>
					<GsLink
						v-if="page.to"
						:to="page.to"
						class="flex items-center h-full"
						:class="[
							(noHome && idx > 0) || !noHome ? 'ml-3' :'',
							twMerge('text-sm font-medium text-gray-500 hover:text-accent dark:text-white', linkClass)
						]"
						:aria-current="idx === items.length-1 ? 'page' : undefined"
						no-prefetch
					>
						<Item.reuse :page="page" />
					</GsLink>
					<span
						v-else
						class="flex items-center h-full"
						:class="[
							(noHome && idx > 0) || !noHome ? 'ml-3' :'',
							twMerge('text-sm font-medium text-current', textClass)
						]"
						:aria-current="idx === items.length-1 ? 'page' : undefined"
					>
						<Item.reuse :page="page" />
					</span>
				</div>
			</li>
		</ol>
	</nav>
</template>
